<div *ngIf="isShowCookie" class="cookie">
  <div class="cookie__content">
    <p class="cookie__message">
      By using our website you consent to accepting cookies in accordance with our Cookie Policy.
      <a class="link" id="cookie-panel/cookie-notice" href="{{ cookieUrl }}" target="_blank" rel="noopener" aria-label="Our cookie notice opens in a new window">Learn more</a>
    </p>
    <button class="cookie__button dlg-button dlg-button--accept dlg-button--auto" (click)="onCookieAccepted()">Accept</button>
  </div>
<div>
